import { gql } from "@apollo/client";

export const CALL_STATUS = gql`
  query CallStatus {
    callStatus {
      aircallEnabled
      hasAircallMapping
    }
  }
`;

export const CALLS = gql`
  query Calls(
    $where: CallWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    calls(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        aircallId
        direction
        phoneNumber
        duration
        startedAt
        answeredAt
        endedAt
        dialedAt
        updatedDate
        user {
          id
          firstname
          lastname
        }
        missedCallReason
        recordingAvailable
        answeredByVoicemail
        status
        project {
          id
          contact {
            id
            user {
              firstname
              lastname
            }
          }
        }
        contact {
          id
          user {
            firstname
            lastname
          }
        }
      }
      count
    }
  }
`;

export const CALL_RECORDING_URL = gql`
  query CallRecordingUrl($callId: ID!) {
    callRecordingUrl(callId: $callId) {
      url
      error
    }
  }
`;

const calls = { CALL_STATUS, CALLS, CALL_RECORDING_URL };

export default calls;
